import React from "react";

function _Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-6 text-start">
            <p className="mb-0">
              <a
                className="text-muted"
                href="_"
                target="_blank"
              >
              </a>{" "}
              
                <strong>Hariri©40hari</strong>
            </p>
          </div>
          <div className="col-6 text-end">
            <ul className="list-inline">
              <li className="list-inline-item">
                <a
                  className="text-muted"
                  href="_"
                  target="_blank"
                >
                  Support
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  className="text-muted"
                  href="_"
                  target="_blank"
                >
                  Help Center
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  className="text-muted"
                  href="_"
                  target="_blank"
                >
                  Privacy
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  className="text-muted"
                  href="_"
                  target="_blank"
                >
                  Terms
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default _Footer;
